var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseWindowWidth',{key:_vm.remount,attrs:{"tag":_vm.tag,"callback":_vm.handleCallback}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }